module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADESURBVChTXZAxCgIxFEQVwcLGygsIdvaCpdfwBB5CsPUCHkCs0pkiZBO3Em3sbL2B1TYWWhhnyEBYH3yyOzP//5DOP9baQYzxhkpVVe0kZ4wxPRhHmqgT/2VlQghbmt77O86h5AzMlTqfqLHkDHYt0PWB8cL3THIGwhRGg8AX51JyAYErDI7eS2pT1/Uc5pvFVZLbcLRWNLjsRHIbmBsUVz2ccyPJhZRSF90HhjDtjEfqyypQROjCEMNsklXgeK7J6+L6B4ghlh3LyeyZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/icon_arrowright.png
// module id = 1276
// module chunks = 525